import { render, staticRenderFns } from "./surveyTableDetail.vue?vue&type=template&id=67c2fd20&scoped=true"
import script from "./surveyTableDetail.vue?vue&type=script&lang=js"
export * from "./surveyTableDetail.vue?vue&type=script&lang=js"
import style0 from "./surveyTableDetail.vue?vue&type=style&index=0&id=67c2fd20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c2fd20",
  null
  
)

export default component.exports